import * as Constants from './constants'

// const RESIDENT = "resident"
// const SECONDARY_USER = "secondary_user"
const GUARD = "guard"
// const PROPERTY_MANAGER = "property_manager"
// const HOA_ADMIN = "hoa_admin"
// const ADMIN = "admin"
// const CT_ADMIN = "ct_admin"

export const featureEnabledForRole = (feature, role) => {
    switch (feature) {
        case Constants.SCAN_KEY_MODAL: {
            return roleIsAtLeast(GUARD, role)
        }
        default: {
            return false
        }
    }
}

function roleIsAtLeast(requiredRole, inputRole) {
    const roleMap = {
        "resident": 1,
        "secondary_user": 2,
        "guard": 3,
        "property_manager": 4,
        "hoa_admin": 5,
        "admin": 6,
        "ct_admin": 7
    }
    let requiredLevel = roleMap[requiredRole]
    let userLevel = roleMap[inputRole]

    if (requiredLevel === undefined) {
        throw new Error(`Unknown required role: ${requiredRole}`);
    }

    if (userLevel === undefined) {
        throw new Error(`Unknown user role: ${inputRole}`);
    }

    console.log(`Role evaluation input: ${userLevel} required: ${requiredLevel}`)

    return (userLevel >= requiredLevel)
}